<div fxFlex="column" style="padding: 10px;width: 100%;">

    <div fxLayoutAlign="space-between center">
        <h2 mat-dialog-title>Select a Template</h2>

        <div>
            <button [attr.guide]="'ecommercetemplate-btn-1' + '__' + sanitizedUrl" (click)="close()" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>


    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">


        <div fxLayout="row wrap" >
            <div fxFlex="33.33%" *ngFor="let template of templateList"
                class="template-card-wrapper">
                <div class="template-card">
                    <img [src]="template.logo" [alt]="template.name" class="template-image" />

                    <div class="template-content">
                        <h3 fxLayoutAlign="center center" class="template-title">{{ template.name  | titlecase }}</h3>

                        <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center" class="template-buttons">
                            <button [attr.guide]="'ecommercetemplate-btn-2' + '__' + sanitizedUrl" mat-stroked-button color="primary"
                                (click)="$event.stopPropagation(); viewTemplate(template.link)">
                                View
                            </button>

                            <button [attr.guide]="'ecommercetemplate-btn-3' + '__' + sanitizedUrl" mat-raised-button color="primary" (click)="saveTemplate(template)">
                                Use Template
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </mat-dialog-content>

</div>